/*
 * Copyright 2024 Collaterate. All rights reserved.
 */

var controller = {
    mode: controllerMode.FIELD_CHANGE_QUOTE,
    fieldChangeQuotePending: false,
    getFullQuotePending: false,
    enterFullQuoteMode: function () {
        this.mode = controllerMode.FULL_QUOTE;
        this.getFullQuotePending = false;
        return this.mode;
    },
    exitFullQuoteMode: function (sourceContextConfigChangeDetails) {
        if (this.mode == controllerMode.FIELD_CHANGE_QUOTE) {
            return this.mode;
        }
        this.mode = controllerMode.FIELD_CHANGE_QUOTE;
        if (this.fieldChangeQuotePending && !this.getFullQuotePending) {
            this.getFullQuotePending = true;
            setTimeout(function () {
                controller.getFullQuote(sourceContextConfigChangeDetails);
            }, 1);
        }
        return this.mode;
    },
    fullQuoteFlags: {
        isCustomDimensions: false
    },
    initialize: function () {
        var configChangeDetails = {
            context: 'init',
            category: confUtil.INIT
        };

        // init page
        var cometRequest = comet.newRequest(chandler, 'INIT', function (cometRequest) {
            configureglobals.set('coffering', cometRequest.getObject('WORKINGOFFERING'));
            configureglobals.set('ctips', cometRequest.getObject('TIPS'));
            var pjc = cometRequest.getObject('WORKINGPJC');
            if (configuratorGlobals.isQuoteModePrivileged) {
                // If an option is visible for this product, always allow it to be editable when in privileged mode.
                if (pjc.showCoverPressSheetType) {
                    pjc.editCoverPressSheetType = true;
                }
                if (pjc.showCoverPressSheetWeight) {
                    pjc.editCoverPressSheetWeight = true;
                }
                if (pjc.showCoverPressSheetColor) {
                    pjc.editCoverPressSheetColor = true;
                }
                if (pjc.showCoverSide1Ink) {
                    pjc.editCoverSide1Ink = true;
                }
                if (pjc.showCoverSide2Ink) {
                    pjc.editCoverSide2Ink = true;
                    pjc.requireCoverSide2Ink = false;
                }
                if (pjc.showSide1Ink) {
                    pjc.editSide1Ink = true;
                }
                if (pjc.showSide2Ink) {
                    pjc.editSide2Ink = true;
                    pjc.requireSide2Ink = false;
                    pjc.matchSide1AndSide2Ink = false;
                }
                if (pjc.showPressSheetType) {
                    pjc.editPressSheetType = true;
                }
                if (pjc.showPressSheetWeight) {
                    pjc.editPressSheetWeight = true;
                }
                if (pjc.showPressSheetColor) {
                    pjc.editPressSheetColor = true;
                }
            }
            configureglobals.set('cpjc', pjc);
            controller.calcUIFullInitCallback(cometRequest, configChangeDetails, cometRequest.getObject('QUOTE_INIT_WARNING_MESSAGES'));
            configureEvents.onCalcLoaded();
            configureEvents.onQuoteUpdated(configChangeDetails);
            controller.onSmallQuoteComplete(configureglobals.cquote != null);
            if (typeof shippingCalcWidgetController == 'object') {
                var cshippingcountrylist = cometRequest.getObject(shippingCalcWidgetController.countryListName).list;
                var cshippingcountry = cometRequest.getObject(shippingCalcWidgetController.countryDD);
                var cshippingzip = cometRequest.getObject(shippingCalcWidgetController.zipEF);
                var cshowEstimateShipping = cometRequest.getObject('SHOW_ESTIMATE_SHIPPING');
                shippingCalcWidgetController.initialize(chandler, cshippingcountrylist, cshippingcountry, cshippingzip, cshowEstimateShipping.value);
            }
            configureglobals.set('productionPlan', cometRequest.getObject('PRODUCTION_PLAN'));
            if (configureglobals.productionPlan) {
                window.tbg.eventHub.trigger(window.tbg.eventHub.events.PRODUCTION_PLAN_SET, [configureglobals.productionPlan.jsonObject.array]);
            } else {
                window.tbg.eventHub.trigger(window.tbg.eventHub.events.PRODUCTION_PLAN_SET, [[]]);
            }
        });
        cometRequest.addObjectId(common.offeringId);
        cometRequest.addObjectId2(configuratorGlobals.orderItemId);
        cometRequest.addParameter('reorder', getUrlParm('reorder'));
        cometRequest.addParameter('p', getUrlParm('p'));
        cometRequest.addParameter('q', getUrlParm('q'));
        cometRequest.send();
    },
    calcUIFullInitCallback: function (cometRequest, configChangeDetails, quoteInitWarningMessages) {
        if (cometRequest.sessionTracking) {
            growlMessages.showAll(cometRequest);
            common.setCQuoteData(cometRequest.getObject('QUOTEINPUTDATA'), quoteInitWarningMessages);
            common.setCQuote(cometRequest.getObject('STANDARDQUOTE'));
            configureglobals.set('cdevicemgr', cometRequest.getObject('DEVICEDD'));
            configureglobals.set('cpresssheetmgr', cometRequest.getObject('PRESSSHEETTYPEDD'));
            configureglobals.set('cside1inkmgr', cometRequest.getObject('SIDE1DD'));
            configureglobals.set('cside2inkmgr', cometRequest.getObject('SIDE2DD'));
            configureglobals.set('ccoverpresssheetmgr', cometRequest.getObject('COVERPRESSSHEETTYPEDD'));
            configureglobals.set('ccoverside1inkmgr', cometRequest.getObject('COVERSIDE1DD'));
            configureglobals.set('ccoverside2inkmgr', cometRequest.getObject('COVERSIDE2DD'));
            configureglobals.set('coperationsmgr', cometRequest.getObject('OPERATIONDD'));
            configureglobals.set('coperationgroupset', cometRequest.getObject('OPERATION_GROUP_SET'));
            controller.display();
            common.generateProofs();
            common.generateTurnaroundTimes();
            var isRequoteMode = !!configureCommonGlobals.REQUOTE_MODE;
            var isFullQuoteMode = configChangeDetails && configChangeDetails.category && configChangeDetails.category === confUtil.FULL_QUOTE;
            if (!isRequoteMode && !isFullQuoteMode) {
                common.generateAdditionalFields();
            }
            var cpjc = configureglobals.cpjc;
            if (cpjc.multiPages) {
                dynamic.setClass('printSettings', 'multipage');
            }
        } else {
            var content = '';
            content += '<div id="userMessageError">This site requires browser cookies to be enabled.<br />Please enable cookies and reload this page.</div>';
            dynamic.setDivIdContent('calculator', content);
        }
    },
    onLogin: function () {
        controller.getQuote(true, function () {
            var configChangeDetails = {
                context: 'onLogin',
                category: confUtil.LOGIN
            };
            configureEvents.onQuoteUpdated(configChangeDetails);
        });
    },
    generateDeviceChoices: function () {
        if ((configureglobals.cpjc.showDeviceTypes == true || configuratorGlobals.isQuoteModePrivileged == true) && dynamic.divIdExists('deviceType')) {
            var fieldName = 'DEVICEDD';
            var cquote = configureglobals.cquote;
            var content = '';
            var error = common.validation.hasJobQuoteFieldMessagesFor(fieldName);
            var mgr = configureglobals.cdevicemgr;
            var cdevicechoices = mgr.elementChoices;
            var selectedcdevicechoice = mgr.choice;
            var help = '';
            if (configureglobals.cpjc.showDeviceTypeTip) {
                help = tags.a('Help', 'javascript:help.tip(configureglobals.cpjc,\'deviceTypeTip\',\'' + TBGBOTip.DEVICES + '\')', {
                    id: 'deviceTypeTip',
                    cssClass: 'quoteHelp',
                    tabindex: '-1',
                    title: 'More Information'
                });
            }
            if (configureglobals.cpjc.editDeviceType == true || configuratorGlobals.isQuoteModePrivileged == true) {
                if (mgr.autoDeviceSwitch) {
                    // if auto, the device isn't known until the quote is run.
                    content += help + '<label class="config">' + mgr.label + '</label>';
                    if (cquote != null) {
                        var pjQuote = cquote.pjQuote;
                        if (pjQuote != null) {
                            var device = pjQuote.device;
                            content += tags.div(device.type.name, {
                                id: 'deviceTypeFromQuote',
                                cssClass: 'noEdit'
                            });
                        }
                    }
                    if (configureglobals.cpjc.showAutoDeviceOption || configuratorGlobals.isQuoteModePrivileged == true) {
                        content += tags.a('Let me choose the print method', 'javascript:controller.setAutoDevice(false)', {
                            cssClass: 'togglePreset'
                        });
                    }
                } else {
                    content += help + '<label class="config">' + mgr.label + '</label>';
                    content += forms.dd(fieldName, cdevicechoices, selectedcdevicechoice, {
                        showNullOption: false,
                        cssClass: 'configSelect' + (error ? ' error' : ''),
                        onchange: 'controller.setDevice()'
                    });
                    if (configureglobals.cpjc.showAutoDeviceOption || configuratorGlobals.isQuoteModePrivileged == true) {
                        content += tags.a('Use the print method with the best price', 'javascript:controller.setAutoDevice(true)', {
                            cssClass: 'togglePreset'
                        });
                    }
                    if (error) {
                        content += common.validation.generateJobQuoteFieldMessagesFor(fieldName);
                    }
                }
            } else {
                // if auto, the device isn't known until the quote is run.
                if (mgr.autoDeviceSwitch) {
                    content += help + '<label class="config">' + mgr.label + '</label>';
                    if (cquote != null) {
                        var pjQuote = cquote.pjQuote;
                        if (pjQuote != null) {
                            var device = pjQuote.device;
                            content += tags.div(device.type.name, {
                                id: 'deviceTypeFromQuote',
                                cssClass: 'noEdit'
                            });
                        }
                    }
                } else if (selectedcdevicechoice != null) {
                    content += help + '<label class="config">' + mgr.label + '</label>';
                    content += tags.div(selectedcdevicechoice.name, {
                        cssClass: 'noEdit'
                    });
                }
            }
            common.setOptionDiv('deviceType', content);
        }
    },
    setAutoDevice: function (auto) {
        var configChangeDetails = {
            context: 'setAutoDevice',
            category: confUtil.OPTION_CHANGE,
            value: auto,
            previousValue: !auto,
            newValue: auto
        };
        configureEvents.onCalcChanged(configChangeDetails);
        var cometRequest = comet.newRequest(chandler, 'SETAUTODEVICEBESTPRICE', function (cometRequest) {
            common.setCQuoteData(cometRequest.getObject('QUOTEINPUTDATA'));

            // common.setCQuote(cometRequest.getObject('STANDARDQUOTE'));
            configureglobals.set('cdevicemgr', cometRequest.getObject('DEVICEDD'));
            configureglobals.set('cpresssheetmgr', cometRequest.getObject('PRESSSHEETTYPEDD'));
            configureglobals.set('ccoverpresssheetmgr', cometRequest.getObject('COVERPRESSSHEETTYPEDD'));
            configureglobals.set('cside1inkmgr', cometRequest.getObject('SIDE1DD'));
            configureglobals.set('cside2inkmgr', cometRequest.getObject('SIDE2DD'));
            growlMessages.showAll(cometRequest);
            controller.generateDeviceChoices();
            controller.generatePressSheetTypeChoices();
            controller.generatePressSheetWeightChoices();
            controller.generatePressSheetColorChoices();
            controller.generateCoverPressSheetTypeChoices();
            controller.generateCoverPressSheetWeightChoices();
            controller.generateCoverPressSheetColorChoices();
            controller.generateInkChoices();
            controller.getQuote(false, function () {
                configureEvents.onQuoteUpdated(configChangeDetails);
            });
        });
        cometRequest.addParameter('AUTO_DEVICE_CB', auto);
        cometRequest.send();
    },
    setDevice: function () {
        var configChangeDetails = {
            context: 'setDevice',
            category: confUtil.FIELD_CHANGE,
            fieldName: 'DEVICEDD',
            fieldType: 'DD',
            previousValue: null,
            newValue: getDropDownSelectedValue('DEVICEDD', document)
        };
        configureEvents.onCalcChanged(configChangeDetails);
        var cometRequest = comet.newRequest(chandler, 'SETDEVICE', function (cometRequest) {
            common.setCQuoteData(cometRequest.getObject('QUOTEINPUTDATA'));
            common.setCQuote(cometRequest.getObject('STANDARDQUOTE'));
            configureglobals.set('cdevicemgr', cometRequest.getObject('DEVICEDD'));
            configureglobals.set('cpresssheetmgr', cometRequest.getObject('PRESSSHEETTYPEDD'));
            configureglobals.set('ccoverpresssheetmgr', cometRequest.getObject('COVERPRESSSHEETTYPEDD'));
            configureglobals.set('cside1inkmgr', cometRequest.getObject('SIDE1DD'));
            configureglobals.set('cside2inkmgr', cometRequest.getObject('SIDE2DD'));
            growlMessages.showAll(cometRequest);
            controller.generatePressSheetTypeChoices();
            controller.generatePressSheetWeightChoices();
            controller.generatePressSheetColorChoices();
            controller.generateCoverPressSheetTypeChoices();
            controller.generateCoverPressSheetWeightChoices();
            controller.generateCoverPressSheetColorChoices();
            controller.generateInkChoices();
            controller.getQuote(false, function () {
                configureEvents.onQuoteUpdated(configChangeDetails);
            });
        });
        cometRequest.statusDivId = 'jobQuote';
        cometRequest.addDropDown('DEVICEDD', false, document);
        cometRequest.send();
    },
    getPressSheetTypeChoicesDivId: function () {
        return configureglobals.cpjc.multiPages ? 'pagesPressSheetType' : 'pressSheetType';
    },
    generatePressSheetTypeChoices: function () {
        var divId = this.getPressSheetTypeChoicesDivId();
        if (configureglobals.cpjc.showPressSheetType == true && dynamic.divIdExists(divId)) {
            var fieldName = 'PRESSSHEETTYPEDD';
            var content = '';
            var error = common.validation.hasJobQuoteFieldMessagesFor(fieldName);
            var mgr = configureglobals.cpresssheetmgr;
            var cchoices = mgr.typeElements;
            var cselected = mgr.typeChoice;
            var help = '';
            if (configureglobals.cpjc.showPressSheetTypeTip) {
                help = tags.a('Help', 'javascript:help.tip(configureglobals.cpjc,\'pressSheetTypeTip\',\'' + TBGBOTip.PRESSSHEETTYPES + '\')', {
                    id: 'pressSheetTypeTip',
                    cssClass: 'quoteHelp',
                    tabindex: '-1',
                    title: 'More Information'
                });
            }
            if (configureglobals.cpjc.editPressSheetType == true) {
                content += help + '<label class="config">' + mgr.typeLabel + '</label>';
                content += forms.dd(fieldName, cchoices, cselected, {
                    showNullOption: false,
                    cssClass: 'configSelect' + (error ? ' error' : ''),
                    onchange: 'controller.setPressSheetType()'
                });
                if (error) {
                    content += common.validation.generateJobQuoteFieldMessagesFor(fieldName);
                }
            } else {
                content += help + '<label class="config">' + mgr.typeLabel + '</label>';
                if (cselected == null) {
                    content += tags.div('None', {
                        cssClass: 'noEdit'
                    });
                } else {
                    content += tags.div(cselected.name, {
                        cssClass: 'noEdit'
                    });
                }
            }
            common.setOptionDiv(divId, content);
        }
    },
    setPressSheetType: function () {
        var configChangeDetails = {
            context: 'setPressSheetType',
            category: confUtil.FIELD_CHANGE,
            fieldName: 'PRESSSHEETTYPEDD',
            fieldType: 'DD',
            previousValue: null,
            newValue: getDropDownSelectedValue('PRESSSHEETTYPEDD', document)
        };
        configureEvents.onCalcChanged(configChangeDetails);
        var cometRequest = comet.newRequest(chandler, 'SETPRESSSHEETTYPE', function (cometRequest) {
            common.setCQuoteData(cometRequest.getObject('QUOTEINPUTDATA'));
            common.setCQuote(cometRequest.getObject('STANDARDQUOTE'));
            configureglobals.set('cpresssheetmgr', cometRequest.getObject('PRESSSHEETTYPEDD'));
            configureglobals.set('ccoverpresssheetmgr', cometRequest.getObject('COVERPRESSSHEETTYPEDD'));
            configureglobals.set('cside1inkmgr', cometRequest.getObject('SIDE1DD'));
            configureglobals.set('cside2inkmgr', cometRequest.getObject('SIDE2DD'));
            growlMessages.showAll(cometRequest);
            controller.generatePressSheetWeightChoices();
            controller.generatePressSheetColorChoices();
            controller.generateCoverPressSheetTypeChoices();
            controller.generateCoverPressSheetWeightChoices();
            controller.generateCoverPressSheetColorChoices();
            controller.generateInkChoices();
            controller.getQuote(false, function () {
                configureEvents.onQuoteUpdated(configChangeDetails);
            });
        });
        cometRequest.statusDivId = 'jobQuote';
        cometRequest.addDropDown('PRESSSHEETTYPEDD', false, document);
        cometRequest.send();
    },
    getPressSheetWeightChoicesDivId: function () {
        return configureglobals.cpjc.multiPages ? 'pagesPressSheetWeight' : 'pressSheetWeight';
    },
    generatePressSheetWeightChoices: function () {
        var divId = controller.getPressSheetWeightChoicesDivId();
        if (configureglobals.cpjc.showPressSheetWeight == true && dynamic.divIdExists(divId)) {
            var fieldName = 'PRESSSHEETWEIGHTDD';
            var content = '';
            var error = common.validation.hasJobQuoteFieldMessagesFor(fieldName);
            var mgr = configureglobals.cpresssheetmgr;
            var cchoices = mgr.weightElements;
            var cselected = mgr.weightChoice;
            var help = '';
            if (configureglobals.cpjc.showPressSheetWeightTip) {
                help = tags.a('Help', 'javascript:help.tip(configureglobals.cpjc,\'pressSheetWeightTip\',\'' + TBGBOTip.PRESSSHEETWEIGHTS + '\')', {
                    id: 'pressSheetWeightTip',
                    cssClass: 'quoteHelp',
                    tabindex: '-1',
                    title: 'More Information'
                });
            }
            if (configureglobals.cpjc.editPressSheetWeight == true) {
                content += help + '<label class="config">' + mgr.weightLabel + '</label>';
                content += forms.dd(fieldName, cchoices, cselected, {
                    showNullOption: false,
                    cssClass: 'configSelect' + (error ? ' error' : ''),
                    onchange: 'controller.setPressSheetWeight()'
                });
                if (error) {
                    content += common.validation.generateJobQuoteFieldMessagesFor(fieldName);
                }
            } else {
                content += help + '<label class="config">' + mgr.weightLabel + '</label>';
                if (cselected == null) {
                    content += tags.div('None', {
                        cssClass: 'noEdit'
                    });
                } else {
                    content += tags.div(cselected.name, {
                        cssClass: 'noEdit'
                    });
                }
            }
            common.setOptionDiv(divId, content);
        }
    },
    setPressSheetWeight: function () {
        var configChangeDetails = {
            context: 'setPressSheetWeight',
            category: confUtil.FIELD_CHANGE,
            fieldName: 'PRESSSHEETWEIGHTDD',
            fieldType: 'DD',
            previousValue: null,
            newValue: getDropDownSelectedValue('PRESSSHEETWEIGHTDD', document)
        };
        configureEvents.onCalcChanged(configChangeDetails);
        var cometRequest = comet.newRequest(chandler, 'SETPRESSSHEETWEIGHT', function (cometRequest) {
            common.setCQuoteData(cometRequest.getObject('QUOTEINPUTDATA'));
            common.setCQuote(cometRequest.getObject('STANDARDQUOTE'));
            configureglobals.set('cpresssheetmgr', cometRequest.getObject('PRESSSHEETTYPEDD'));
            configureglobals.set('ccoverpresssheetmgr', cometRequest.getObject('COVERPRESSSHEETTYPEDD'));
            configureglobals.set('cside1inkmgr', cometRequest.getObject('SIDE1DD'));
            configureglobals.set('cside2inkmgr', cometRequest.getObject('SIDE2DD'));
            growlMessages.showAll(cometRequest);
            controller.generatePressSheetColorChoices();
            controller.generateCoverPressSheetTypeChoices();
            controller.generateCoverPressSheetWeightChoices();
            controller.generateCoverPressSheetColorChoices();
            controller.generateInkChoices();
            controller.getQuote(false, function () {
                configureEvents.onQuoteUpdated(configChangeDetails);
            });
        });
        cometRequest.statusDivId = 'jobQuote';
        cometRequest.addDropDown('PRESSSHEETWEIGHTDD', false, document);
        cometRequest.send();
    },
    getPressSheetColorChoicesDivId: function () {
        return configureglobals.cpjc.multiPages ? 'pagesPressSheetColor' : 'pressSheetColor';
    },
    generatePressSheetColorChoices: function () {
        var divId = controller.getPressSheetColorChoicesDivId();
        if (configureglobals.cpjc.showPressSheetColor == true && dynamic.divIdExists(divId)) {
            var fieldName = 'PRESSSHEETCOLORDD';
            var content = '';
            var error = common.validation.hasJobQuoteFieldMessagesFor(fieldName);
            var mgr = configureglobals.cpresssheetmgr;
            var cchoices = mgr.colorElements;
            var cselected = mgr.colorChoice;
            var help = '';
            if (configureglobals.cpjc.showPressSheetColorTip) {
                help = tags.a('Help', 'javascript:help.tip(configureglobals.cpjc,\'pressSheetColorTip\',\'' + TBGBOTip.PRESSSHEETCOLORS + '\')', {
                    id: 'pressSheetColorTip',
                    cssClass: 'quoteHelp',
                    tabindex: '-1',
                    title: 'More Information'
                });
            }
            if (configureglobals.cpjc.editPressSheetColor == true) {
                content += help + '<label class="config">' + mgr.colorLabel + '</label>';
                content += forms.dd(fieldName, cchoices, cselected, {
                    showNullOption: false,
                    cssClass: 'configSelect' + (error ? ' error' : ''),
                    onchange: 'controller.setPressSheetColor()'
                });
                if (error) {
                    content += common.validation.generateJobQuoteFieldMessagesFor(fieldName);
                }
            } else {
                content += help + '<label class="config">' + mgr.colorLabel + '</label>';
                if (cselected == null) {
                    content += tags.div('None', {
                        cssClass: 'noEdit'
                    });
                } else {
                    content += tags.div(cselected.name, {
                        cssClass: 'noEdit'
                    });
                }
            }
            common.setOptionDiv(divId, content);
        }
    },
    setPressSheetColor: function () {
        var configChangeDetails = {
            context: 'setPressSheetColor',
            category: confUtil.FIELD_CHANGE,
            fieldName: 'PRESSSHEETCOLORDD',
            fieldType: 'DD',
            previousValue: null,
            newValue: getDropDownSelectedValue('PRESSSHEETCOLORDD', document)
        };
        configureEvents.onCalcChanged(configChangeDetails);
        var cometRequest = comet.newRequest(chandler, 'SETPRESSSHEETCOLOR', function (cometRequest) {
            common.setCQuoteData(cometRequest.getObject('QUOTEINPUTDATA'));
            common.setCQuote(cometRequest.getObject('STANDARDQUOTE'));
            configureglobals.set('cpresssheetmgr', cometRequest.getObject('PRESSSHEETTYPEDD'));
            configureglobals.set('ccoverpresssheetmgr', cometRequest.getObject('COVERPRESSSHEETTYPEDD'));
            configureglobals.set('cside1inkmgr', cometRequest.getObject('SIDE1DD'));
            configureglobals.set('cside2inkmgr', cometRequest.getObject('SIDE2DD'));
            growlMessages.showAll(cometRequest);
            controller.generateCoverPressSheetTypeChoices();
            controller.generateCoverPressSheetWeightChoices();
            controller.generateCoverPressSheetColorChoices();
            controller.generateInkChoices();
            controller.getQuote(false, function () {
                configureEvents.onQuoteUpdated(configChangeDetails);
            });
        });
        cometRequest.statusDivId = 'jobQuote';
        cometRequest.addDropDown('PRESSSHEETCOLORDD', false, document);
        cometRequest.send();
    },
    getInkChoicesDivId: function () {
        return configureglobals.cpjc.multiPages ? 'pagesSide1Ink' : 'side1Ink';
    },
    generateInkChoices: function () {
        var divId = controller.getInkChoicesDivId();
        if (configureglobals.cpjc.showSide1Ink == true && dynamic.divIdExists(divId)) {
            var fieldName = 'SIDE1DD';
            var content = '';
            var mgr = configureglobals.cside1inkmgr;
            var cside1inkchoices = mgr.elementChoices;
            var selectedcside1inkchoice = mgr.choice;
            var error = common.validation.hasJobQuoteFieldMessagesFor(fieldName);
            var help = '';
            if (configureglobals.cpjc.showSide1InkTip) {
                help = tags.a('Help', 'javascript:help.tip(configureglobals.cpjc,\'side1InkTip\',\'' + TBGBOTip.SIDE1INKS + '\')', {
                    id: 'side1InkTip',
                    cssClass: 'quoteHelp',
                    tabindex: '-1',
                    title: 'More Information'
                });
            }
            if (configureglobals.cpjc.editSide1Ink == true) {
                content += help + '<label class="config">' + mgr.label + '</label>';
                content += forms.dd(fieldName, cside1inkchoices, selectedcside1inkchoice, {
                    showNullOption: false,
                    cssClass: 'configSelect' + (error ? ' error' : ''),
                    onchange: 'controller.setSide1Ink()'
                });
                if (error) {
                    content += common.validation.generateJobQuoteFieldMessagesFor(fieldName);
                }
            } else {
                if (selectedcside1inkchoice != null) {
                    content += help + '<label class="config">' + mgr.label + '</label>';
                    content += tags.div(selectedcside1inkchoice.name, {
                        cssClass: 'noEdit'
                    });
                }
            }
            common.setOptionDiv(divId, content);
        }

        if (configureglobals.cpjc.showSide2Ink && !configureglobals.cpjc.matchSide1AndSide2Ink) {
            var fieldName = 'SIDE2DD';
            var content = '';
            var mgr = configureglobals.cside2inkmgr;
            var cside2inkchoices = mgr.elementChoices;
            var selectedcside2inkchoice = mgr.choice;
            error = common.validation.hasJobQuoteFieldMessagesFor(fieldName);
            var help = '';
            if (configureglobals.cpjc.showSide2InkTip) {
                help = tags.a('Help', 'javascript:help.tip(configureglobals.cpjc,\'side2InkTip\',\'' + TBGBOTip.SIDE2INKS + '\')', {
                    id: 'side2InkTip',
                    cssClass: 'quoteHelp',
                    tabindex: '-1',
                    title: 'More Information'
                });
            }
            if (configureglobals.cpjc.editSide2Ink == true) {
                content += help + '<label class="config">' + mgr.label + '</label>';
                content += forms.dd(fieldName, cside2inkchoices, selectedcside2inkchoice, {
                    showNullOption: !configureglobals.cpjc.requireSide2Ink,
                    nullOption: 'None',
                    cssClass: 'configSelect' + (error ? ' error' : ''),
                    onchange: 'controller.setSide2Ink()'
                });
                if (error) {
                    content += common.validation.generateJobQuoteFieldMessagesFor(fieldName);
                }
            } else {
                if (selectedcside2inkchoice != null) {
                    content += help + '<label class="config">' + mgr.label + '</label>';
                    content += tags.div(selectedcside2inkchoice.name, {
                        cssClass: 'noEdit'
                    });
                }
            }
            common.setOptionDiv(configureglobals.cpjc.multiPages ? 'pagesSide2Ink' : 'side2Ink', content);
        }
    },
    setSide1Ink: function () {
        var configChangeDetails = {
            context: 'setSide1Ink',
            category: confUtil.FIELD_CHANGE,
            fieldName: 'SIDE1DD',
            fieldType: 'DD',
            previousValue: null,
            newValue: getDropDownSelectedValue('SIDE1DD', document)
        };
        configureEvents.onCalcChanged(configChangeDetails);
        var cometRequest = comet.newRequest(chandler, 'SETSIDE1', function (cometRequest) {
            common.setCQuoteData(cometRequest.getObject('QUOTEINPUTDATA'));
            common.setCQuote(cometRequest.getObject('STANDARDQUOTE'));
            configureglobals.set('cside1inkmgr', cometRequest.getObject('SIDE1DD'));
            configureglobals.set('cside2inkmgr', cometRequest.getObject('SIDE2DD'));
            growlMessages.showAll(cometRequest);
            controller.getQuote(false, function () {
                configureEvents.onQuoteUpdated(configChangeDetails);
            });
        });
        cometRequest.statusDivId = 'jobQuote';
        cometRequest.addDropDown('SIDE1DD', false, document);
        cometRequest.send();
    },
    setSide2Ink: function () {
        var configChangeDetails = {
            context: 'setSide2Ink',
            category: confUtil.FIELD_CHANGE,
            fieldName: 'SIDE2DD',
            fieldType: 'DD',
            previousValue: null,
            newValue: getDropDownSelectedValue('SIDE2DD', document)
        };
        configureEvents.onCalcChanged(configChangeDetails);
        var cometRequest = comet.newRequest(chandler, 'SETSIDE2', function (cometRequest) {
            common.setCQuoteData(cometRequest.getObject('QUOTEINPUTDATA'));
            common.setCQuote(cometRequest.getObject('STANDARDQUOTE'));
            configureglobals.set('cside2inkmgr', cometRequest.getObject('SIDE2DD'));
            growlMessages.showAll(cometRequest);
            controller.getQuote(false, function () {
                configureEvents.onQuoteUpdated(configChangeDetails);
            });
        });
        cometRequest.statusDivId = 'jobQuote';
        cometRequest.addDropDown('SIDE2DD', false, document);
        cometRequest.send();
    },
    generateCoverPressSheetTypeChoices: function () {
        if (configureglobals.cpjc.showCoverPressSheetType == true && dynamic.divIdExists('coverPressSheetType')) {
            var fieldName = 'COVERPRESSSHEETTYPEDD';
            var content = '';
            var error = common.validation.hasJobQuoteFieldMessagesFor(fieldName);
            var mgr = configureglobals.ccoverpresssheetmgr;
            var cchoices = mgr.typeElements;
            var cselected = mgr.typeChoice;
            var help = '';
            if (configureglobals.cpjc.showCoverPressSheetTypeTip) {
                help = tags.a('Help', 'javascript:help.tip(configureglobals.cpjc,\'coverPressSheetTypeTip\',\'' + TBGBOTip.COVERPRESSSHEETTYPES + '\')', {
                    id: 'coverPressSheetTypeTip',
                    cssClass: 'quoteHelp',
                    tabindex: '-1',
                    title: 'More Information'
                });
            }
            if (configureglobals.cpjc.editCoverPressSheetType == true) {
                content += help + '<label class="config">' + mgr.typeLabel + '</label>';
                content += forms.dd(fieldName, cchoices, cselected, {
                    showNullOption: false,
                    cssClass: 'configSelect' + (error ? ' error' : ''),
                    onchange: 'controller.setCoverPressSheetType()'
                });
                if (error) {
                    content += common.validation.generateJobQuoteFieldMessagesFor(fieldName);
                }
            } else {
                content += help + '<label class="config">' + mgr.typeLabel + '</label>';
                if (cselected == null) {
                    content += tags.div('None', {
                        cssClass: 'noEdit'
                    });
                } else {
                    content += tags.div(cselected.name, {
                        cssClass: 'noEdit'
                    });
                }
            }
            common.setOptionDiv('coverPressSheetType', content);
        }
    },
    setCoverPressSheetType: function () {
        var configChangeDetails = {
            context: 'setCoverPressSheetType',
            category: confUtil.FIELD_CHANGE,
            fieldName: 'COVERPRESSSHEETTYPEDD',
            fieldType: 'DD',
            previousValue: null,
            newValue: getDropDownSelectedValue('COVERPRESSSHEETTYPEDD', document)
        };
        configureEvents.onCalcChanged(configChangeDetails);
        var cometRequest = comet.newRequest(chandler, 'SETCOVERPRESSSHEETTYPE', function (cometRequest) {
            common.setCQuoteData(cometRequest.getObject('QUOTEINPUTDATA'));
            common.setCQuote(cometRequest.getObject('STANDARDQUOTE'));
            configureglobals.set('ccoverpresssheetmgr', cometRequest.getObject('COVERPRESSSHEETTYPEDD'));
            growlMessages.showAll(cometRequest);
            controller.generateCoverPressSheetWeightChoices();
            controller.generateCoverPressSheetColorChoices();
            controller.getQuote(false, function () {
                configureEvents.onQuoteUpdated(configChangeDetails);
            });
        });
        cometRequest.statusDivId = 'jobQuote';
        cometRequest.addDropDown('COVERPRESSSHEETTYPEDD', false, document);
        cometRequest.send();
    },
    generateCoverPressSheetWeightChoices: function () {
        if (configureglobals.cpjc.showCoverPressSheetWeight == true && dynamic.divIdExists('coverPressSheetWeight')) {
            var fieldName = 'COVERPRESSSHEETWEIGHTDD';
            var content = '';
            var error = common.validation.hasJobQuoteFieldMessagesFor(fieldName);
            var mgr = configureglobals.ccoverpresssheetmgr;
            var cchoices = mgr.weightElements;
            var cselected = mgr.weightChoice;
            var help = '';
            if (configureglobals.cpjc.showCoverPressSheetWeightTip) {
                help = tags.a('Help', 'javascript:help.tip(configureglobals.cpjc,\'coverPressSheetWeightTip\',\'' + TBGBOTip.COVERPRESSSHEETWEIGHTS + '\')', {
                    id: 'coverPressSheetWeightTip',
                    cssClass: 'quoteHelp',
                    tabindex: '-1',
                    title: 'More Information'
                });
            }
            if (configureglobals.cpjc.editCoverPressSheetWeight == true) {
                content += help + '<label class="config">' + mgr.weightLabel + '</label>';
                content += forms.dd(fieldName, cchoices, cselected, {
                    showNullOption: false,
                    cssClass: 'configSelect' + (error ? ' error' : ''),
                    onchange: 'controller.setCoverPressSheetWeight()'
                });
                if (error) {
                    content += common.validation.generateJobQuoteFieldMessagesFor(fieldName);
                }
            } else {
                content += help + '<label class="config">' + mgr.weightLabel + '</label>';
                if (cselected == null) {
                    content += tags.div('None', {
                        cssClass: 'noEdit'
                    });
                } else {
                    content += tags.div(cselected.name, {
                        cssClass: 'noEdit'
                    });
                }
            }
            common.setOptionDiv('coverPressSheetWeight', content);
        }
    },
    setCoverPressSheetWeight: function () {
        var configChangeDetails = {
            context: 'setCoverPressSheetWeight',
            category: confUtil.FIELD_CHANGE,
            fieldName: 'COVERPRESSSHEETWEIGHTDD',
            fieldType: 'DD',
            previousValue: null,
            newValue: getDropDownSelectedValue('COVERPRESSSHEETWEIGHTDD', document)
        };
        configureEvents.onCalcChanged(configChangeDetails);
        var cometRequest = comet.newRequest(chandler, 'SETCOVERPRESSSHEETWEIGHT', function (cometRequest) {
            common.setCQuoteData(cometRequest.getObject('QUOTEINPUTDATA'));
            common.setCQuote(cometRequest.getObject('STANDARDQUOTE'));
            configureglobals.set('ccoverpresssheetmgr', cometRequest.getObject('COVERPRESSSHEETTYPEDD'));
            growlMessages.showAll(cometRequest);
            controller.generateCoverPressSheetColorChoices();
            controller.getQuote(false, function () {
                configureEvents.onQuoteUpdated(configChangeDetails);
            });
        });
        cometRequest.statusDivId = 'jobQuote';
        cometRequest.addDropDown('COVERPRESSSHEETWEIGHTDD', false, document);
        cometRequest.send();
    },
    generateCoverPressSheetColorChoices: function () {
        if (configureglobals.cpjc.showCoverPressSheetColor == true && dynamic.divIdExists('coverPressSheetColor')) {
            var fieldName = 'COVERPRESSSHEETCOLORDD';
            var content = '';
            var error = common.validation.hasJobQuoteFieldMessagesFor(fieldName);
            var mgr = configureglobals.ccoverpresssheetmgr;
            var cchoices = mgr.colorElements;
            var cselected = mgr.colorChoice;
            var help = '';
            if (configureglobals.cpjc.showCoverPressSheetColorTip) {
                help = tags.a('Help', 'javascript:help.tip(configureglobals.cpjc,\'coverPressSheetColorTip\',\'' + TBGBOTip.COVERPRESSSHEETCOLORS + '\')', {
                    id: 'coverPressSheetColorTip',
                    cssClass: 'quoteHelp',
                    tabindex: '-1',
                    title: 'More Information'
                });
            }
            if (configureglobals.cpjc.editCoverPressSheetColor == true) {
                content += help + '<label class="config">' + mgr.colorLabel + '</label>';
                content += forms.dd(fieldName, cchoices, cselected, {
                    showNullOption: false,
                    cssClass: 'configSelect' + (error ? ' error' : ''),
                    onchange: 'controller.setCoverPressSheetColor()'
                });
                if (error) {
                    content += common.validation.generateJobQuoteFieldMessagesFor(fieldName);
                }
            } else {
                content += help + '<label class="config">' + mgr.colorLabel + '</label>';
                if (cselected == null) {
                    content += tags.div('None', {
                        cssClass: 'noEdit'
                    });
                } else {
                    content += tags.div(cselected.name, {
                        cssClass: 'noEdit'
                    });
                }
            }
            common.setOptionDiv('coverPressSheetColor', content);
        }
    },
    setCoverPressSheetColor: function () {
        var configChangeDetails = {
            context: 'setCoverPressSheetColor',
            category: confUtil.FIELD_CHANGE,
            fieldName: 'COVERPRESSSHEETCOLORDD',
            fieldType: 'DD',
            previousValue: null,
            newValue: getDropDownSelectedValue('COVERPRESSSHEETCOLORDD', document)
        };
        configureEvents.onCalcChanged(configChangeDetails);
        var cometRequest = comet.newRequest(chandler, 'SETCOVERPRESSSHEETCOLOR', function (cometRequest) {
            common.setCQuoteData(cometRequest.getObject('QUOTEINPUTDATA'));
            common.setCQuote(cometRequest.getObject('STANDARDQUOTE'));
            configureglobals.set('ccoverpresssheetmgr', cometRequest.getObject('COVERPRESSSHEETTYPEDD'));
            growlMessages.showAll(cometRequest);
            controller.getQuote(false, function () {
                configureEvents.onQuoteUpdated(configChangeDetails);
            });
        });
        cometRequest.statusDivId = 'jobQuote';
        cometRequest.addDropDown('COVERPRESSSHEETCOLORDD', false, document);
        cometRequest.send();
    },
    generateCoverInkChoices: function () {
        if (configureglobals.cpjc.showCoverSide1Ink == true && dynamic.divIdExists('coverSide1Ink')) {
            var fieldName = 'COVERSIDE1DD';
            var content = '';
            var mgr = configureglobals.ccoverside1inkmgr;
            var choices = mgr.elementChoices;
            var selectedchoice = mgr.choice;
            var error = common.validation.hasJobQuoteFieldMessagesFor(fieldName);
            var help = '';
            if (configureglobals.cpjc.showCoverSide1InkTip) {
                help = tags.a('Help', 'javascript:help.tip(configureglobals.cpjc,\'coverSide1InkTip\',\'' + TBGBOTip.COVERSIDE1INKS + '\')', {
                    id: 'coverSide1InkTip',
                    cssClass: 'quoteHelp',
                    tabindex: '-1',
                    title: 'More Information'
                });
            }
            if (configureglobals.cpjc.editCoverSide1Ink == true) {
                content += help + '<label class="config">' + mgr.label + '</label>';
                content += forms.dd(fieldName, choices, selectedchoice, {
                    showNullOption: false,
                    cssClass: 'configSelect' + (error ? ' error' : ''),
                    onchange: 'controller.setCoverSide1Ink()'
                });
                if (error) {
                    content += common.validation.generateJobQuoteFieldMessagesFor(fieldName);
                }
            } else {
                if (selectedchoice != null) {
                    content += help + '<label class="config">' + mgr.label + '</label>';
                    content += tags.div(selectedchoice.name, {
                        cssClass: 'noEdit'
                    });
                }
            }
            common.setOptionDiv('coverSide1Ink', content);
        }

        //
        if (configureglobals.cpjc.showCoverSide2Ink == true && dynamic.divIdExists('coverSide2Ink')) {
            var fieldName = 'COVERSIDE2DD';
            var content = '';
            var mgr = configureglobals.ccoverside2inkmgr;
            var choices = mgr.elementChoices;
            var selectedchoice = mgr.choice;
            error = common.validation.hasJobQuoteFieldMessagesFor(fieldName);
            var help = '';
            if (configureglobals.cpjc.showCoverSide2InkTip) {
                help = tags.a('Help', 'javascript:help.tip(configureglobals.cpjc,\'coverSide2InkTip\',\'' + TBGBOTip.COVERSIDE2INKS + '\')', {
                    id: 'coverSide2InkTip',
                    cssClass: 'quoteHelp',
                    tabindex: '-1',
                    title: 'More Information'
                });
            }
            if (configureglobals.cpjc.editCoverSide2Ink == true) {
                content += help + '<label class="config">' + mgr.label + '</label>';
                content += forms.dd(fieldName, choices, selectedchoice, {
                    showNullOption: !configureglobals.cpjc.requireCoverSide2Ink,
                    nullOption: 'None',
                    cssClass: 'configSelect' + (error ? ' error' : ''),
                    onchange: 'controller.setCoverSide2Ink()'
                });
                if (error) {
                    content += common.validation.generateJobQuoteFieldMessagesFor(fieldName);
                }
            } else {
                if (selectedchoice != null) {
                    content += help + '<label class="config">' + mgr.label + '</label>';
                    content += tags.div(selectedchoice.name, {
                        cssClass: 'noEdit'
                    });
                }
            }
            common.setOptionDiv('coverSide2Ink', content);
        }
    },
    setCoverSide1Ink: function () {
        var configChangeDetails = {
            context: 'setCoverSide1Ink',
            category: confUtil.FIELD_CHANGE,
            fieldName: 'COVERSIDE1DD',
            fieldType: 'DD',
            previousValue: null,
            newValue: getDropDownSelectedValue('COVERSIDE1DD', document)
        };
        configureEvents.onCalcChanged(configChangeDetails);
        var cometRequest = comet.newRequest(chandler, 'SETCOVERSIDE1', function (cometRequest) {
            common.setCQuoteData(cometRequest.getObject('QUOTEINPUTDATA'));
            common.setCQuote(cometRequest.getObject('STANDARDQUOTE'));
            configureglobals.set('ccoverside1inkmgr', cometRequest.getObject('COVERSIDE1DD'));
            growlMessages.showAll(cometRequest);
            controller.getQuote(false, function () {
                configureEvents.onQuoteUpdated(configChangeDetails);
            });
        });
        cometRequest.statusDivId = 'jobQuote';
        cometRequest.addDropDown('COVERSIDE1DD', false, document);
        cometRequest.send();
    },
    setCoverSide2Ink: function () {
        var configChangeDetails = {
            context: 'setCoverSide2Ink',
            category: confUtil.FIELD_CHANGE,
            fieldName: 'COVERSIDE2DD',
            fieldType: 'DD',
            previousValue: null,
            newValue: getDropDownSelectedValue('COVERSIDE2DD', document)
        };
        configureEvents.onCalcChanged(configChangeDetails);
        var cometRequest = comet.newRequest(chandler, 'SETCOVERSIDE2', function (cometRequest) {
            common.setCQuoteData(cometRequest.getObject('QUOTEINPUTDATA'));
            common.setCQuote(cometRequest.getObject('STANDARDQUOTE'));
            configureglobals.set('ccoverside2inkmgr', cometRequest.getObject('COVERSIDE2DD'));
            growlMessages.showAll(cometRequest);
            controller.getQuote(false, function () {
                configureEvents.onQuoteUpdated(configChangeDetails);
            });
        });
        cometRequest.statusDivId = 'jobQuote';
        cometRequest.addDropDown('COVERSIDE2DD', false, document);
        cometRequest.send();
    },
    generateBleedDiv: function () {
        if (configureglobals.cpjc.showBleed == true && dynamic.divIdExists('bleedDiv')) {
            var fieldName = 'BLEEDDD';
            var content = '';
            var error = common.validation.hasJobQuoteFieldMessagesFor(fieldName);
            var isbleed = configureglobals.cquotedata.bleed;
            var help = '';
            if (configureglobals.cpjc.showBleedTip) {
                help = tags.a('Help', 'javascript:help.tip(configureglobals.cpjc,\'bleedTip\',\'' + TBGBOTip.BLEED + '\')', {
                    id: 'bleedTip',
                    cssClass: 'quoteHelp',
                    tabindex: '-1',
                    title: 'More Information'
                });
            }
            if (configureglobals.cpjc.editBleed == true) {
                content += help + '<label class="config">' + configureglobals.cquotedata.bleedLabel + '</label>';
                var yes = new DDOption('Yes', 'Yes');
                content += forms.dd(fieldName, [yes], isbleed ? yes : null, {
                    nullOption: 'No',
                    cssClass: 'configSelect' + (error ? ' error' : ''),
                    onchange: 'controller.setBleed()'
                });
                if (error) {
                    content += common.validation.generateJobQuoteFieldMessagesFor(fieldName);
                }
            } else {
                content += help + '<label class="config">' + configureglobals.cquotedata.bleedLabel + '</label>';
                content += tags.div(isbleed ? 'Yes' : 'No', {
                    cssClass: 'noEdit'
                });
            }
            common.setOptionDiv('bleedDiv', content);
        }
    },
    setBleed: function () {
        var configChangeDetails = {
            context: 'setBleed',
            category: confUtil.FIELD_CHANGE,
            fieldName: 'BLEEDDD',
            fieldType: 'DD',
            previousValue: null,
            newValue: getDropDownSelectedValue('BLEEDDD', document)
        };
        configureEvents.onCalcChanged(configChangeDetails);
        var cometRequest = comet.newRequest(chandler, 'SETBLEED', function (cometRequest) {
            common.setCQuoteData(cometRequest.getObject('QUOTEINPUTDATA'));
            common.setCQuote(cometRequest.getObject('STANDARDQUOTE'));
            growlMessages.showAll(cometRequest);
            controller.getQuote(false, function () {
                configureEvents.onQuoteUpdated(configChangeDetails);
            });
        });
        cometRequest.statusDivId = 'jobQuote';
        cometRequest.addDropDown('BLEEDDD', false, document);
        cometRequest.send();
    },
    generateDimensionsDiv: function () {
        if ((configureglobals.cpjc.showDimensions || configuratorGlobals.isQuoteModePrivileged) && dynamic.divIdExists('dimensionsDiv')) {
            var widthName = 'WIDTHEF';
            var heightName = 'HEIGHTEF';
            var dimensionsName = 'PRESETDIMENSIONSDD';
            var customType = configureCommonGlobals.CUSTOM_DIMENSIONS;
            var presetType = configureCommonGlobals.PRESET_DIMENSIONS;
            var presetDimensions = configureglobals.cpjc.presetDimensions;
            var content = '';
            var cquotedata = configureglobals.cquotedata;
            var error = common.validation.hasJobQuoteFieldMessagesFor(widthName);
            var help = '';
            if (configureglobals.cpjc.showDimensionsTip) {
                help = tags.a('Help', 'javascript:help.tip(configureglobals.cpjc,\'dimensionsTip\',\'' + TBGBOTip.DIMENSIONS + '\')', {
                    id: 'dimensionsTip',
                    cssClass: 'quoteHelp',
                    tabindex: '-1',
                    title: 'More Information'
                });
            }
            if (configureglobals.cpjc.editDimensions == true || configuratorGlobals.isQuoteModePrivileged) {
                content += help + '<label class="config">' + configureglobals.cpjc.dimensionsTitle + '</label>';
                var dimType = configureglobals.cpjc.dimensionsType.id;
                if (dimType == customType || cquotedata.customDimensionsOption == true) {
                    controller.fullQuoteFlags.isCustomDimensions = true;
                    content += '<div class="customDimensions">';
                    content += forms.ef(widthName, cquotedata.width, {
                        size: 5,
                        cssClass: 'configField' + (error ? ' error' : ''),
                        onfocus: 'common.efFocus(\'' + widthName + '\',\'dimensionsDiv\', \'dimensionsFocus\')',
                        onblur: 'common.efBlur(\'' + widthName + '\',\'dimensionsDiv\', \'dimensionsFocus\')'
                    });
                    content += ' &#215; ';
                    content += forms.ef(heightName, cquotedata.height, {
                        size: 5,
                        cssClass: 'configField' + (error ? ' error' : ''),
                        onfocus: 'common.efFocus(\'' + heightName + '\',\'dimensionsDiv\', \'dimensionsFocus\')',
                        onblur: 'common.efBlur(\'' + heightName + '\',\'dimensionsDiv\', \'dimensionsFocus\')'
                    });
                    content += '<span id="dimensionsFocus" class="changeFocusButton"><!-- dynamic --></span>';
                    content += '</div>';
                    if (dimType == presetType && cquotedata.customDimensionsOption == true) {
                        content += tags.a('Use Preset Dimensions', 'javascript:controller.setCustomDimensionsOption(false)', {
                            cssClass: 'togglePreset presets'
                        });
                    }
                } else if (dimType == presetType) {
                    var ddoptions = {
                        showNullOption: false,
                        cssClass: 'configSelect' + (error ? ' error' : ''),
                        onchange: 'controller.setDimensions()',
                        propertyFunction: function (object) {
                            return object.width + ' x ' + object.height;
                        }
                    };
                    content += forms.dd(dimensionsName, presetDimensions, cquotedata.presetDimensions, ddoptions);
                    if (dimType == presetType && configureglobals.cpjc.showCustomDimensionsOption) {
                        controller.fullQuoteFlags.isCustomDimensions = false;
                        content += tags.a('Use Custom Dimensions', 'javascript:controller.setCustomDimensionsOption(true)', {
                            cssClass: 'togglePreset customs'
                        });
                    }
                }
                if (error) {
                    content += common.validation.generateJobQuoteFieldMessagesFor(widthName);
                }
            } else {
                content += help + '<label class="config">' + configureglobals.cpjc.dimensionsTitle + '</label>';
                content += tags.div(cquotedata.width + ' x ' + cquotedata.height, {
                    cssClass: 'noEdit'
                });
            }
            common.setOptionDiv('dimensionsDiv', content);
        }
    },
    setCustomDimensionsOption: function (bool) {
        var configChangeDetails = {
            context: 'setCustomDimensionsOption',
            category: confUtil.OPTION_CHANGE,
            value: bool,
            previousValue: !bool,
            newValue: bool
        };
        configureEvents.onCalcChanged(configChangeDetails);
        controller.fullQuoteFlags.isCustomDimensions = bool;
        var cometRequest = comet.newRequest(chandler, 'SETCUSTOMDIMENSIONSOPTION', function (cometRequest) {
            common.setCQuoteData(cometRequest.getObject('QUOTEINPUTDATA'));
            growlMessages.showAll(cometRequest);
            controller.display();
            configureEvents.onQuoteUpdated(configChangeDetails);
            if (!bool) {
                controller.setDimensions();
            }
        });
        cometRequest.addParameter('CUSTOM_DIMENSIONS_CB', bool);
        cometRequest.send();
    },
    setDimensions: function () {
        var configChangeDetails = {
            context: 'setDimensions',
            category: confUtil.FIELD_CHANGE,
            fieldName: 'PRESETDIMENSIONSDD',
            fieldType: 'DD',
            previousValue: null,
            newValue: getDropDownSelectedValue('PRESETDIMENSIONSDD', document)
        };
        configureEvents.onCalcChanged(configChangeDetails);
        var cometRequest = comet.newRequest(chandler, 'SETPRESETDIMENSIONS', function (cometRequest) {
            common.setCQuoteData(cometRequest.getObject('QUOTEINPUTDATA'));
            common.setCQuote(cometRequest.getObject('STANDARDQUOTE'));
            growlMessages.showAll(cometRequest);
            controller.getQuote(false, function () {
                configureEvents.onQuoteUpdated(configChangeDetails);
            });
        });
        cometRequest.statusDivId = 'jobQuote';
        cometRequest.addDropDown('PRESETDIMENSIONSDD', false, document);
        cometRequest.send();
    },
    generatePagesDiv: function () {
        if (configureglobals.cpjc.showPages == true && dynamic.divIdExists('pagesDiv')) {
            var fieldName = 'PAGESEF';
            var content = '';
            var cquotedata = configureglobals.cquotedata;
            var error = common.validation.hasJobQuoteFieldMessagesFor(fieldName);
            var help = '';
            if (configureglobals.cpjc.showPagesTip) {
                help = tags.a('Help', 'javascript:help.tip(configureglobals.cpjc,\'pagesTip\',\'' + TBGBOTip.PAGES + '\')', {
                    id: 'pagesTip',
                    cssClass: 'quoteHelp',
                    tabindex: '-1',
                    title: 'More Information'
                });
            }
            if (configureglobals.cpjc.editPages == true) {
                content += help + '<label class="config">' + cquotedata.pagesLabel + '</label>';
                content += forms.ef(fieldName, cquotedata.pages, {
                    size: 5,
                    cssClass: 'configField' + (error ? ' error' : ''),
                    onfocus: 'common.efFocus(\'' + fieldName + '\',\'pagesDiv\', \'pagesFocus\')',
                    onblur: 'common.efBlur(\'' + fieldName + '\',\'pagesDiv\', \'pagesFocus\')'
                });
                content += '<span id="pagesFocus" class="changeFocusButton"><!-- dynamic --></span>';
                if (error) {
                    content += common.validation.generateJobQuoteFieldMessagesFor(fieldName);
                }
            } else {
                content += help + '<label class="config">' + cquotedata.pagesLabel + '</label>';
                content += tags.div(cquotedata.pages, {
                    cssClass: 'noEdit'
                });
            }
            common.setOptionDiv('pagesDiv', content);
        }
    },
    generatePiecesOnSheetOverrideDiv: function () {
        if (dynamic.divIdExists('piecesOnSheetOverrideDiv') && configuratorGlobals.isQuoteModePrivileged) {
            var fieldName = 'PIECES_ON_SHEET_OVERRIDE_EF';
            var content = '';
            var cquotedata = configureglobals.cquotedata;
            var error = common.validation.hasJobQuoteFieldMessagesFor(fieldName);
            var pjQuote = configureglobals.cquote ? configureglobals.cquote.pjQuote : null;
            var overridePiecesOnSheet = pjQuote && pjQuote.pressSheetQuote.piecesOnSheetOverride > 0 ? pjQuote.pressSheetQuote.piecesOnSheetOverride : 'Auto';
            content += '<label class="config">Pieces On Sheet</label>';
            content += forms.ef(fieldName, overridePiecesOnSheet, {
                style: 'width:70px',
                cssClass: 'configField' + (error ? ' error' : ''),
                onfocus: 'common.efFocus(\'' + fieldName + '\',\'piecesOnSheetOverrideDiv\', \'piecesOnSheetOverrideFocus\')',
                onblur: 'common.efBlur(\'' + fieldName + '\',\'piecesOnSheetOverrideDiv\', \'piecesOnSheetOverrideFocus\')'
            });
            content += '<span id="piecesOnSheetOverrideFocus" class="changeFocusButton"><!-- dynamic --></span>';
            if (overridePiecesOnSheet != 'Auto') {
                content += tags.a('Auto Calculate', 'javascript:controller.setDefaultPiecesOnSheet()', {
                    cssClass: 'togglePreset'
                });
            }
            if (error) {
                content += common.validation.generateJobQuoteFieldMessagesFor(fieldName);
            }
            common.setOptionDiv('piecesOnSheetOverrideDiv', content);
        }
    },
    setDefaultPiecesOnSheet: function () {
        // simulate the user clearing the field.
        setFieldValue('PIECES_ON_SHEET_OVERRIDE_EF', '', null);
        common.efBlur('PIECES_ON_SHEET_OVERRIDE_EF', 'piecesOnSheetOverrideDiv', 'piecesOnSheetOverrideFocus');
    },
    generateCoverPiecesOnSheetOverrideDiv: function () {
        if (dynamic.divIdExists('coverPiecesOnSheetOverrideDiv') && configuratorGlobals.isQuoteModePrivileged) {
            var fieldName = 'COVER_PIECES_ON_SHEET_OVERRIDE_EF';
            var content = '';
            var cquotedata = configureglobals.cquotedata;
            var error = common.validation.hasJobQuoteFieldMessagesFor(fieldName);
            var pjQuote = configureglobals.cquote ? configureglobals.cquote.pjQuote : null;
            var overridePiecesOnSheet = pjQuote && pjQuote.coverPressSheetQuote.piecesOnSheetOverride > 0 ? pjQuote.coverPressSheetQuote.piecesOnSheetOverride : 'Auto';
            content += '<label class="config">Pieces on Cover Sheet</label>';
            content += forms.ef(fieldName, overridePiecesOnSheet, {
                style: 'width:70px',
                cssClass: 'configField' + (error ? ' error' : ''),
                onfocus: 'common.efFocus(\'' + fieldName + '\',\'coverPiecesOnSheetOverrideDiv\', \'coverPiecesOnSheetOverrideFocus\')',
                onblur: 'common.efBlur(\'' + fieldName + '\',\'coverPiecesOnSheetOverrideDiv\', \'coverPiecesOnSheetOverrideFocus\')'
            });
            content += '<span id="coverPiecesOnSheetOverrideFocus" class="changeFocusButton"><!-- dynamic --></span>';
            if (overridePiecesOnSheet != 'Auto') {
                content += tags.a('Auto Calculate', 'javascript:controller.setDefaultCoverPiecesOnSheet()', {
                    cssClass: 'togglePreset'
                });
            }
            if (error) {
                content += common.validation.generateJobQuoteFieldMessagesFor(fieldName);
            }
            common.setOptionDiv('coverPiecesOnSheetOverrideDiv', content);
        }
    },
    setDefaultCoverPiecesOnSheet: function () {
        // simulate the user clearing the field.
        setFieldValue('COVER_PIECES_ON_SHEET_OVERRIDE_EF', '', null);
        common.efBlur('COVER_PIECES_ON_SHEET_OVERRIDE_EF', 'coverPiecesOnSheetOverrideDiv', 'coverPiecesOnSheetOverrideFocus');
    },
    generateOverrideAmountDiv: function () {
        if (dynamic.divIdExists('overrideAmountDiv') && configuratorGlobals.isQuoteModePrivileged) {
            var fieldName = 'TOTAL_PRICE_OVERRIDE_AMOUNT_EF';
            var content = '';
            var cquotedata = configureglobals.cquotedata;
            var error = common.validation.hasJobQuoteFieldMessagesFor(fieldName);

            content += '<h3>Price Adjustment</h3>';
            content += forms.ef(fieldName, cquotedata.totalPriceOverrideAmount, {
                size: 15,
                style: 'width:auto',
                cssClass: 'configField' + (error ? ' error' : ''),
                onfocus: 'common.efFocus(\'' + fieldName + '\',\'overrideAmountDiv\', \'overrideAmountFocus\')',
                onblur: 'common.efBlur(\'' + fieldName + '\',\'overrideAmountDiv\', \'overrideAmountFocus\')'
            });
            content += '<span id="overrideAmountFocus" class="changeFocusButton"><!-- dynamic --></span>';
            if (error) {
                content += common.validation.generateJobQuoteFieldMessagesFor(fieldName);
            }
            common.setOptionDiv('overrideAmountDiv', content);
        }
    },
    operationEntryFields: null,
    generateOperationsDiv: function () {
        this.operationEntryFields = [];

        var content = '';
        var coperationsmgr = configureglobals.coperationsmgr;
        var coperations = coperationsmgr.operations;
        var operationGroupSet = configureglobals.coperationgroupset;
        var operationGroups = operationGroupSet ? operationGroupSet.operationGroups : [];
        var groupData = prepareOperationGroupData(operationGroups, coperations);

        if (groupData.length && coperations) {
            for (var i = 0, className = ''; i < groupData.length; i++) {
                className = generateClassName(groupData[i].label);

                content += '<div class="operationsGroupWrapper operationsGroupWrapper--' + className + '">';
                content += '<h3>' + groupData[i].label + '</h3>';
                content += '<fieldset class="operationsGroup">';
                for (var j = 0; j < groupData[i].operations.length; j++) {
                    content += prepareOperationMarkup(groupData[i].operations[j], groupData[i].operations[j].originalIndex);
                }
                content += '</fieldset>';
                content += '</div>';
            }
        } else if (coperations) {
            for (var i = 0; i < coperations.length; i++) {
                content += prepareOperationMarkup(coperations[i], i);
            }
        }

        if (content.length && !operationGroupSet) {
            content = '<h3>Finishing</h3><fieldset class="operationsGroup">' + content + '</fieldset>';
        } else if (!content.length) {
            dynamic.setClass('operationsDiv', 'optionWrapperEmpty');
        }

        dynamic.setDivIdContent('operationsDiv', content);

        return;

        function generateClassName (label) {
            return label
                .trim()
                .toLowerCase()
                .replace(/\s\s*/g, '-');
        }

        function prepareOperationMarkup (operationData, i) {
            var content = '';
            var ddName = 'OPERATIONDD';
            var cpjcoperation = operationData.pjcOperation;
            var coperationchoices = operationData.choices;
            var cchoice = operationData.choice;
            var help = '';
            var dderror,
                efName,
                fieldName,
                eferror;
            var internalOnly = false;
            var getChoiceDisplayName = function (cchoice) {
                var displayName = cchoice.name;
                if (cchoice.adminOnly) {
                    displayName += ' (Internal Only)';
                }
                return displayName;
            };

            // if privilegedMode, override and always show.
            if (configuratorGlobals.isQuoteModePrivileged) {
                // when showing an operation that would normally be hidden but for privileged mode, show internal only label.
                if (!cpjcoperation.show) {
                    internalOnly = true;
                }
                cpjcoperation.show = true;
                operationData.editable = true;
            }

            // Hide internal only operations if there are 0 to 1 choices
            if (internalOnly && (!coperationchoices || coperationchoices.length < 2)) {
                cpjcoperation.show = false;
            }

            if (cpjcoperation.show) {
                if (cpjcoperation.showTip) {
                    help = tags.a('', 'javascript:help.opTip(' + i + ')', {
                        id: 'opTip' + i,
                        cssClass: 'quoteHelp',
                        tabindex: '-1',
                        title: 'More Information'
                    });
                }

                content += '<div class="optionWrapperOn' + (cpjcoperation.operation.costingOnly ? ' costingOnly' : '') + '" id="operation' + cpjcoperation.operation.id + '">';
                if (internalOnly) {
                    content += help + '<label class="config internal-only">' + strWeb(operationData.heading) + ' (Internal Only)</label>';
                } else {
                    content += help + '<label class="config">' + strWeb(operationData.heading) + '</label>';
                }

                if (operationData.editable) {
                    dderror = common.validation.hasJobQuoteFieldMessagesFor(ddName + i);

                    content += forms.dd(ddName + i, coperationchoices, cchoice, {
                        showNullOption: !cpjcoperation.required,
                        nullOption: 'None',
                        cssClass: dderror ? 'opSelectError' : 'opSelect',
                        onchange: 'controller.setOperation(' + i + ',' + cpjcoperation.operation.id + ')',
                        id: 'operation' + cpjcoperation.operation.id,
                        propertyFunction: getChoiceDisplayName
                    });

                    if (dderror) {
                        content += common.validation.generateJobQuoteFieldMessagesFor(ddName + i);
                    }

                    // item question
                    if (cchoice && operationData.showItemQuestion) {
                        efName = 'OPERATIONITEMANSWEREF';
                        fieldName = efName + i;
                        eferror = common.validation.hasJobQuoteFieldMessagesFor(fieldName);

                        content += '<div id="operationItemDiv' + i + '" class="op">';
                        content += '<label class="opQuestion">' + operationData.itemQuestion + '</label>';
                        content += forms.ef(fieldName, operationData.itemAnswerIntType ? operationData.itemAnswerInt : strWeb(operationData.itemAnswer), {
                            id: 'operationAnswer' + cpjcoperation.operation.id,
                            size: 22,
                            cssClass: 'configField' + (eferror ? ' error' : ''),
                            onfocus: 'common.efFocus(\'' + fieldName + '\',\'operationItemDiv' + i + '\', \'operationFocus' + i + '\')',
                            onblur: 'common.efBlur(\'' + fieldName + '\',\'operationItemDiv' + i + '\', \'operationFocus' + i + '\')'
                        });
                        content += '<span id="operationFocus' + i + '" class="changeFocusButton"><!-- dynamic --></span>';

                        controller.operationEntryFields[controller.operationEntryFields.length] = fieldName;

                        if (eferror) {
                            content += common.validation.generateJobQuoteFieldMessagesFor(fieldName);
                        }

                        content += '</div>';
                    }
                } else {
                    if (cchoice) {
                        content += tags.div(strWeb(cchoice.name), {
                            cssClass: 'noEdit'
                        });
                    }
                }

                content += '</div><!-- optionWrapper -->';
            }

            return content;
        }

        function prepareOperationGroupData (groups, opData) {
            var operationGroupData = [];
            var operations;

            if (!groups || !groups.length || !opData) {
                return operationGroupData;
            }

            // We are going to alter the array, make a copy of it
            // to leave original intact for other users
            operationData = opData.slice();

            // Save original index for use in things like tips etc...
            for (var i = 0; i < operationData.length; i++) {
                operationData[i].originalIndex = i;
            }

            // Loop through groups and match any listed operations
            // to operationData items returned for this product
            for (var j = 0, entry, tempOperations; j < groups.length; j++) {
                entry = {
                    label: groups[j].label,
                    operations: []
                };

                tempOperations = [];

                for (var k = 0, ii; k < groups[j].operations.length; k++) {
                    ii = 0;
                    while (ii < operationData.length) {
                        if (groups[j].operations[k].id === operationData[ii].pjcOperation.operation.id) {
                            if (operationData[ii].pjcOperation.show) {
                                tempOperations.push(operationData[ii]);
                            }
                            operationData.splice(ii, 1);
                            continue;
                        }
                        ii++;
                    }
                }

                if (tempOperations.length) {
                    entry.operations = tempOperations;
                    operationGroupData.push(entry);
                }
            }

            // If there are any operationData items not sorted into a group yet,
            // add them to a catch all group
            if (operationData.length) {
                operationGroupData.push({
                    label: 'Other',
                    operations: operationData
                });
            }

            return operationGroupData;
        }
    },
    setOperation: function (index, id) {
        if (this.mode != controllerMode.FIELD_CHANGE_QUOTE) {
            controller.fieldChangeQuotePending = true;
            return;
        }
        var configChangeDetails = {
            context: 'setOperation',
            category: confUtil.INDEXED_FIELD_CHANGE,
            fieldIndex: index,
            fieldNamePrefix: 'OPERATIONDD',
            fieldID: 'operation' + id,
            fieldType: 'DD',
            previousValue: null,
            newValue: null
        };
        configureEvents.onCalcChanged(configChangeDetails);

        var cometRequest = comet.newRequest(chandler, 'SETOPERATION', function (cometRequest) {
            common.setCQuoteData(cometRequest.getObject('QUOTEINPUTDATA'));
            common.setCQuote(cometRequest.getObject('STANDARDQUOTE'));
            configureglobals.set('coperationsmgr', cometRequest.getObject('OPERATIONDD'));
            growlMessages.showAll(cometRequest);
            controller.getQuote(false, function () {
                configureEvents.onQuoteUpdated(configChangeDetails);
            });
        });
        cometRequest.statusDivId = 'jobQuote';
        cometRequest.addObject('OPERATIONDD', {
            selections: [this.buildOperationSelectionResource(index, configureglobals.coperationsmgr.operations[index])]
        });
        cometRequest.send();
    },
    parentController: null,
    onSmallQuoteComplete: function (success) {
        if (this.parentController != null) {
            this.parentController.smallQuoteComplete(success);
        }
        if (typeof shippingCalcWidgetController == 'object') {
            shippingCalcWidgetController.onQuoteChange();
        }
    },
    display: function () {
        controller.generateDeviceChoices();
        controller.generatePressSheetTypeChoices();
        controller.generatePressSheetWeightChoices();
        controller.generatePressSheetColorChoices();
        controller.generateInkChoices();
        controller.generateCoverPressSheetTypeChoices();
        controller.generateCoverPressSheetWeightChoices();
        controller.generateCoverPressSheetColorChoices();
        controller.generateCoverInkChoices();
        controller.generateBleedDiv();
        controller.generateDimensionsDiv();
        controller.generatePagesDiv();
        controller.generateOverrideAmountDiv();
        controller.generatePiecesOnSheetOverrideDiv();
        controller.generateCoverPiecesOnSheetOverrideDiv();
        quantityConfigureController.generateQuantity();
        controller.generateOperationsDiv();
    },
    getQuote: function (isLogin, onQuoteUpdatedFunction, onQuoteUpdateFailedFunction) {
        if (this.mode != controllerMode.FIELD_CHANGE_QUOTE) {
            controller.fieldChangeQuotePending = true;
            return;
        }
        var cometRequest = comet.newRequest(chandler, 'GET_FIELD_CHANGE_QUOTE_ACTION', function (cometRequest) {
            common.setCQuoteData(cometRequest.getObject('QUOTEINPUTDATA'));
            common.setCQuote(cometRequest.getObject('STANDARDQUOTE'));
            configureglobals.set('coperationsmgr', cometRequest.getObject('OPERATIONDD'));
            configureglobals.set('productionPlan', cometRequest.getObject('PRODUCTION_PLAN'));
            if (configureglobals.productionPlan) {
                window.tbg.eventHub.trigger(window.tbg.eventHub.events.PRODUCTION_PLAN_SET, [configureglobals.productionPlan.jsonObject.array]);
            } else {
                window.tbg.eventHub.trigger(window.tbg.eventHub.events.PRODUCTION_PLAN_SET, [[]]);
            }
            growlMessages.showAll(cometRequest);
            controller.display();
            controller.fieldChangeQuotePending = false;
            if (isLogin && typeof shippingCalcWidgetController == 'object') {
                var cshippingcountry = cometRequest.getObject(shippingCalcWidgetController.countryDD);
                var cshippingzip = cometRequest.getObject(shippingCalcWidgetController.zipEF);
                shippingCalcWidgetController.onLogin(cshippingcountry, cshippingzip);
            }
            controller.onSmallQuoteComplete(configureglobals.cquote != null);
            if (common.ef != null) {
                focusOn(common.ef, document);
                selectAll(common.ef, document);
            }
            if (typeof onQuoteUpdatedFunction == 'function') {
                onQuoteUpdatedFunction();
            }
        }, null, onQuoteUpdateFailedFunction);
        this.decorateCometRequestForGetQuote(cometRequest, isLogin);
        dynamic.setDivIdContent('jobQuote', '--');
        cometRequest.send();
    },
    decorateCometRequestForGetQuote: function (cometRequest, isLogin) {
        cometRequest.statusDivId = 'jobQuote';
        cometRequest.addParameter('reorder', getUrlParm('reorder'));
        cometRequest.addParameter('p', getUrlParm('p'));
        if (isLogin) {
            cometRequest.addParameter('ONLOGIN', 'true');
        }
        cometRequest.addFormField('WIDTHEF', false, document);
        cometRequest.addFormField('HEIGHTEF', false, document);
        cometRequest.addFormField('PAGESEF', false, document);
        cometRequest.addFormField('QUANTITYEF', false, document);
        cometRequest.addFormField('QUANTITY_PER_VERSION_EF', false, document);
        cometRequest.addFormField('VERSION_COUNT_EF', false, document);
        cometRequest.addFormField('TOTAL_PRICE_OVERRIDE_AMOUNT_EF', false, document);
        cometRequest.addFormField('PIECES_ON_SHEET_OVERRIDE_EF', false, document);
        cometRequest.addFormField('COVER_PIECES_ON_SHEET_OVERRIDE_EF', false, document);
        for (var i = 0; i < this.operationEntryFields.length; i++) {
            cometRequest.addFormField(this.operationEntryFields[i], false, document);
        }
    },
    getFullQuote: function (sourceContextConfigChangeDetails) {
        var configChangeDetails = {
            category: confUtil.FULL_QUOTE,
            contextLevel: sourceContextConfigChangeDetails == null || !sourceContextConfigChangeDetails.contextLevel ? 1 : sourceContextConfigChangeDetails.contextLevel + 1,
            context: sourceContextConfigChangeDetails
        };

        // submit all fields at once and also getQuote
        var cometRequest = comet.newRequest(chandler, 'GET_FULL_QUOTE_ACTION', function (cometRequest) {
            controller.calcUIFullInitCallback(cometRequest, configChangeDetails);
            configureEvents.onQuoteUpdated(configChangeDetails);
            controller.fieldChangeQuotePending = false;
        });

        // do all decorators here, then decorateCometRequestForGetQuote
        {
            // Each of these "cometRequest.addDropDown" calls are wrapped in an "if" that matches the conditions required to write the corresponding "DD" field to the DOM.
            // This is so that the full-quote mode request does not send a field to the backend that does not exist here.  TBG-3177
            if ((configureglobals.cpjc.showDeviceTypes == true || configuratorGlobals.isQuoteModePrivileged == true) && dynamic.divIdExists('deviceType') && (configureglobals.cpjc.editDeviceType == true || configuratorGlobals.isQuoteModePrivileged == true) && !configureglobals.cdevicemgr.autoDeviceSwitch) {
                cometRequest.addDropDown('DEVICEDD', false, document);
            }
            if (configureglobals.cpjc.showPressSheetType == true && dynamic.divIdExists(controller.getPressSheetTypeChoicesDivId()) && configureglobals.cpjc.editPressSheetType == true) {
                cometRequest.addDropDown('PRESSSHEETTYPEDD', false, document);
            }
            if (configureglobals.cpjc.showPressSheetWeight == true && dynamic.divIdExists(controller.getPressSheetWeightChoicesDivId()) && configureglobals.cpjc.editPressSheetWeight == true) {
                cometRequest.addDropDown('PRESSSHEETWEIGHTDD', false, document);
            }
            if (configureglobals.cpjc.showPressSheetColor == true && dynamic.divIdExists(controller.getPressSheetColorChoicesDivId()) && configureglobals.cpjc.editPressSheetColor == true) {
                cometRequest.addDropDown('PRESSSHEETCOLORDD', false, document);
            }
            if (configureglobals.cpjc.showSide1Ink == true && dynamic.divIdExists(controller.getInkChoicesDivId()) && configureglobals.cpjc.editSide1Ink == true) {
                cometRequest.addDropDown('SIDE1DD', false, document);
            }
            if (configureglobals.cpjc.showSide2Ink && !configureglobals.cpjc.matchSide1AndSide2Ink && configureglobals.cpjc.editSide2Ink == true) {
                cometRequest.addDropDown('SIDE2DD', false, document);
            }
            if (configureglobals.cpjc.showCoverPressSheetType == true && dynamic.divIdExists('coverPressSheetType') && configureglobals.cpjc.editCoverPressSheetType == true) {
                cometRequest.addDropDown('COVERPRESSSHEETTYPEDD', false, document);
            }
            if (configureglobals.cpjc.showCoverPressSheetWeight == true && dynamic.divIdExists('coverPressSheetWeight') && configureglobals.cpjc.editCoverPressSheetWeight == true) {
                cometRequest.addDropDown('COVERPRESSSHEETWEIGHTDD', false, document);
            }
            if (configureglobals.cpjc.showCoverPressSheetColor == true && dynamic.divIdExists('coverPressSheetColor') && configureglobals.cpjc.editCoverPressSheetColor == true) {
                cometRequest.addDropDown('COVERPRESSSHEETCOLORDD', false, document);
            }
            if (configureglobals.cpjc.showCoverSide1Ink == true && dynamic.divIdExists('coverSide1Ink') && configureglobals.cpjc.editCoverSide1Ink == true) {
                cometRequest.addDropDown('COVERSIDE1DD', false, document);
            }
            if (configureglobals.cpjc.showCoverSide2Ink == true && dynamic.divIdExists('coverSide2Ink') && configureglobals.cpjc.editCoverSide2Ink == true) {
                cometRequest.addDropDown('COVERSIDE2DD', false, document);
            }
            if (configureglobals.cpjc.showBleed == true && dynamic.divIdExists('bleedDiv') && configureglobals.cpjc.editBleed == true) {
                cometRequest.addDropDown('BLEEDDD', false, document);
            }
            cometRequest.addParameter('CUSTOM_DIMENSIONS_CB', controller.fullQuoteFlags.isCustomDimensions);
            if ((configureglobals.cpjc.showDimensions || configuratorGlobals.isQuoteModePrivileged) && dynamic.divIdExists('dimensionsDiv') && (configureglobals.cpjc.editDimensions == true || configuratorGlobals.isQuoteModePrivileged) && configureglobals.cpjc.dimensionsType.id == configureCommonGlobals.PRESET_DIMENSIONS) {
                cometRequest.addDropDown('PRESETDIMENSIONSDD', false, document);
            }
            var coffering = configureglobals.coffering;
            if (coffering.getPublishedShowProof() && coffering.getPublishedEditProof()) {
                cometRequest.addDropDown('PROOFDD', false, document);
            }
            if (coffering.getPublishedShowTurnaroundTime() && coffering.getPublishedEditTurnaroundTime()) {
                cometRequest.addDropDown('TURNAROUNDTIMEDD', false, document);
            }

            var operationSelections = new Array();
            $(configureglobals.coperationsmgr.operations).each(function (index, node) {
                if (node.editable) {
                    operationSelections.push(controller.buildOperationSelectionResource(index, node));
                }
            });
            cometRequest.addObject('OPERATIONDD', {
                selections: operationSelections
            });
        }
        controller.decorateCometRequestForGetQuote(cometRequest, false);

        dynamic.setDivIdContent('jobQuote', '--');
        cometRequest.send();
    },
    buildOperationSelectionResource: function (index, operationEntity) {
        return {
            index: index,
            pjcOperationId: operationEntity.pjcOperation.id,
            operationId: operationEntity.pjcOperation.operation.id,
            selectedItemId: parseInt(getDropDownSelectedValue('OPERATIONDD' + index, document), 10)
        };
    }
};

$(function () {
    controller.initialize();
});
